// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ConfigProvider } from "antd";
import { HelmetProvider } from 'react-helmet-async';
import { GlobalStyles } from "./GlobalStyles";
import { StoreContext } from "./hooks/storeContext";
import store from "./_store/index";
import { ROUTES } from "./constants/routes";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RECAPTCHA_SITE_KEY } from './config';

// Wrap your routes with App as the root element
const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: ROUTES
  }
]);

// Conditionally wrap with reCAPTCHA provider (only if site key is configured)
const AppWithProviders = () => {
  const content = (
    <StoreContext.Provider value={store}>
        <ConfigProvider>
            <HelmetProvider>
                <GlobalStyles />
                <RouterProvider router={router} />
            </HelmetProvider>
        </ConfigProvider>
    </StoreContext.Provider>
  );

  if (RECAPTCHA_SITE_KEY) {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
        {content}
      </GoogleReCaptchaProvider>
    );
  }

  return content;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppWithProviders />);